export default __webpack_public_path__ + "static/media/mobile_87.94fcf4af.jpg";